module.exports = __webpack_public_path__ + "media/images/ft.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/ft.png
// module id = 147
// module chunks = 0